module.exports = __webpack_public_path__ + "img/hands.5d9b8985.png";